const exported = {
  getBaseUrl(courseSlug: string): string {
    return `/teach/${courseSlug}/course`;
  },

  getOverviewUrl(courseSlug: string): string {
    return `${this.getBaseUrl(courseSlug)}/overview`;
  },

  getAnalyticsUrl(courseSlug: string): string {
    return `${this.getBaseUrl(courseSlug)}/analytics`;
  },

  getSettingsUrl(courseSlug: string): string {
    return `${this.getBaseUrl(courseSlug)}/settings`;
  },

  getAnnouncementsUrl(courseSlug: string): string {
    return `${this.getBaseUrl(courseSlug)}/announcements`;
  },

  getExportsUrl(courseSlug: string): string {
    return `${this.getBaseUrl(courseSlug)}/analytics/exports`;
  },

  getRostersUrl(courseSlug: string, groupId: string): string {
    return `/teach/${courseSlug}/${groupId}/learners/rosters`;
  },

  getAssignmentsGradingUrl(courseSlug: string, groupId: string): string {
    return `/teach/${courseSlug}/${groupId}/grading/assignment-grading`;
  },

  getEditContentUrl(courseSlug: string, contextId: string): string {
    return `/teach/${courseSlug}/${contextId}/content/edit`;
  },

  getLearnersUrl(courseSlug: string, contextId: string): string {
    return `/teach/${courseSlug}/${contextId}/learners`;
  },

  getSessionSettingsUrl(courseSlug: string, contextId: string): string {
    return `/teach/${courseSlug}/${contextId}/settings`;
  },

  getCourseSettingsUrl(courseSlug: string): string {
    return `/teach/${courseSlug}/course/settings`;
  },

  getSuperuserUrl(courseSlug: string): string {
    return `/teach/${courseSlug}/course/superuser/settings`;
  },

  getViewAsLearnerUrl(courseSlug: string): string {
    return `/learn/${courseSlug}/home/welcome`;
  },
};

export default exported;

export const {
  getBaseUrl,
  getOverviewUrl,
  getAnalyticsUrl,
  getSettingsUrl,
  getAnnouncementsUrl,
  getExportsUrl,
  getRostersUrl,
  getAssignmentsGradingUrl,
  getEditContentUrl,
  getSuperuserUrl,
} = exported;
